import React from 'react'

function EditClientEnvironment({ selectedRow, ClientCompanyTypeData, sendDataToParent }) {
  const formData = selectedRow || ClientCompanyTypeData || {};

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent({
      ...formData,
      [name]: value
    });
  }

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">
            Client Name<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="Name"
            value={formData.Name ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Client Url<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="ClientUrl"
            value={formData.ClientUrl ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            API Url<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="APIUrl"
            value={formData.APIUrl ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Port Number
          </label>
          <input
            type="number"
            className="form-control"
            name="PortNumber"
            value={formData.PortNumber ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Branch<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="BranchName"
            value={formData.BranchName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Database<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="DatabaseName"
            value={formData.DatabaseName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Favicon Path<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="FaviconPath"
            value={formData.FaviconPath ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Website Folder
          </label>
          <input
            type="text"
            className="form-control"
            name="WebsiteFolder"
            value={formData.WebsiteFolder ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Application ID<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="number"
            className="form-control"
            name="ApplicationId"
            value={formData.ApplicationId ?? ""}
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  )
}

export default EditClientEnvironment